/**
 * Test instrumentation, off by default.
 *
 * The end-to-end suite needs to know where each of the room's 2,904 pixels landed on screen. Publishing
 * that on every draw is both a frame-rate hazard (a 2,904-entry JSON.stringify per redraw) and a leak of internals into the page,
 * so the expensive and revealing parts are written ONLY when instrumentation is on: in a dev build, or
 * when the page is opened with `?e2e=1` (which the Playwright suite does against dev, the deployed
 * origin and the Pi-served bundle alike).
 *
 * Cheap, non-revealing counters (element/run counts, selection, zoom) stay on always — they cost
 * nothing and several of them are how the UI itself reports state.
 */
function detect(): boolean {
  try {
    if (import.meta.env.DEV) return true;
    return new URLSearchParams(window.location.search).has('e2e');
  } catch {
    return false;
  }
}

export const instrumented = detect();
